<template>
  <div id="form">

    <b-modal v-if="this.scs" ref="scs-modal" size="xl" scrollable centered @ok="$refs['scs-modal'].show()" title="SCS Action Plan" ok-only ok-variant="secondary" ok-title="Close">
      <p>This report snapshot features the top categories. To see the full list refer to the complete dealership action plan for details.</p>

      <table class="table">
        <tr>
          <th colspan="3">Quantity Of Action Plans</th>
        </tr>
        <tr>
          <th>Technician Recruiting - # of Techs</th>
          <th>Technician Retention</th>
          <th>Training</th>
        </tr>
        <tr>
          <td>{{ this.scs["quantity_of_action_plans"]["people"]["tech_recruiting_num_techs"] }}</td>
          <td>{{ this.scs["quantity_of_action_plans"]["people"]["tech_retention"] }}</td>
          <td>{{ this.scs["quantity_of_action_plans"]["people"]["training"] }}</td>
        </tr>
        <tr>
          <th>Service Lane Technology/Reservations</th>
          <th>QL Express - # of Bays</th>
          <th>VCU/RO Analysis - # Of Analysis</th>
        </tr>
        <tr>
          <td>{{ this.scs["quantity_of_action_plans"]["process"]["service_lane_technology_reservations"] }}</td>
          <td>{{ this.scs["quantity_of_action_plans"]["process"]["ql_express_num_bays"] }}</td>
          <td>{{ this.scs["quantity_of_action_plans"]["process"]["vcu_ro_analysis"] }}</td>
        </tr>
        <tr>
          <th>Pickup & Delivery</th>
          <th>Mobile Service - # of Vans</th>
          <th>Quick Lane Tire & Auto Center - # of Bays</th>
        </tr>
        <tr>
          <td>{{ this.scs["quantity_of_action_plans"]["place"]["pickup_and_delivery"] }}</td>
          <td>{{ this.scs["quantity_of_action_plans"]["place"]["mobile_service_num_vans"] }}</td>
          <td>{{ this.scs["quantity_of_action_plans"]["place"]["ql_tire_auto_center_num_bays"] }}</td>
        </tr>
        <tr>
          <th>Connected Vehicles</th>
          <th>Customer Experience</th>
          <th>Electric Vehicles</th>
        </tr>
        <tr>
          <td>{{ this.scs["quantity_of_action_plans"]["enhancers"]["connected_vehicles"] }}</td>
          <td>{{ this.scs["quantity_of_action_plans"]["enhancers"]["customer_experience"] }}</td>
          <td>{{ this.scs["quantity_of_action_plans"]["enhancers"]["electric_vehicles"] }}</td>
        </tr>
      </table>
    </b-modal>

    <div class="clearfix">
      <h6 class="page-title">Assessment Form</h6>
      <p class="mb-4">
        Review each category below with your dealership. Select all the items in each category that describe their current practices.
        <b-button v-if="this.scs" class="float-right" @click="$refs['scs-modal'].show()">View SCS Action Plan</b-button>
      </p>
      <b-button class="assessment-btn float-right fixed" @click="submitForm" :disabled="!canSubmit" pill>
        Submit Assessment ({{numComplete}}/5)
        <font-awesome-icon class="fa-fw" :icon="['far', 'chevron-right']"/>
      </b-button>

    </div>
    <div class="mt-4">
<!--      <h4 class="tab-main-title">BENCHMARKS</h4>-->
<!--      <div mq="lg+">-->
      <div v-if="ready">
        <b-tabs fill>
          <b-tab title="Compensation" active>
            <template v-slot:title>
              <awesome-check :isCompleted="complete.compensation"></awesome-check>
              Compensation
            </template>
            <b-card-text class="text-left">
              <div class="row">
                <div class="col-md-4 full-tab-border-right">
                  <h6 class="tab-column-heading">Annual Income</h6>

                  <div class="mt-4">
                    <checkgroup storeKey="compensation.c1" v-bind:values="[
                                          'assessmentForm.compensation.c1.q1',
                                          'assessmentForm.compensation.c1.q2',
                                          'assessmentForm.compensation.c1.q3'
                                          ]" v-on:selected="onSelected('assessmentForm.compensation.c1', $event)">
                    </checkgroup>
                  </div>
                </div>
                <div class="col-md-4 full-tab-border-right">
                  <h6 class="tab-column-heading">Pay Plan Methodology and Bonus Structure</h6>
                  <div class="mt-4">
                    <checkgroup storeKey="compensation.c2" v-bind:values="[
                                          'assessmentForm.compensation.c2.q1',
                                          'assessmentForm.compensation.c2.q2',
                                          'assessmentForm.compensation.c2.q3'
                                          ]" v-on:selected="onSelected('assessmentForm.compensation.c2', $event)">
                    </checkgroup>
                  </div>
                </div>
                <div class="col-md-4 last-tab">
                  <h6 class="tab-column-heading">Benefits</h6>
                  <div class="mt-4">
                    <checkgroup storeKey="compensation.c3" v-bind:values="[
                                          'assessmentForm.compensation.c3.q1',
                                          'assessmentForm.compensation.c3.q2',
                                          'assessmentForm.compensation.c3.q3'
                                          ]" v-on:selected="onSelected('assessmentForm.compensation.c3', $event)">
                    </checkgroup>
                  </div>
                </div>
              </div>

            </b-card-text>
          </b-tab>
          <b-tab title="Training">
            <template v-slot:title>
              <awesome-check :isCompleted="complete.training"></awesome-check>
              Training
            </template>
            <b-card-text class="text-left">
              <div class="row">
                <div class="col-md-3 full-tab-border-right">
                  <h6 class="tab-column-heading">{{ $t('assessmentForm.training.c1.title') }}</h6>

                  <div class="mt-4">
                    <checkgroup storeKey="training.c1" v-bind:values="[
                                          'assessmentForm.training.c1.q1',
                                          'assessmentForm.training.c1.q2',
                                          'assessmentForm.training.c1.q3'
                                          ]" v-on:selected="onSelected('assessmentForm.training.c1', $event)">
                    </checkgroup>
                  </div>
                </div>
                <div class="col-md-3 full-tab-border-right">
                  <h6 class="tab-column-heading">{{ $t('assessmentForm.training.c2.title') }}</h6>
                  <div class="mt-4">
                    <checkgroup storeKey="training.c2" v-bind:values="[
                                          'assessmentForm.training.c2.q1',
                                          'assessmentForm.training.c2.q2',
                                          'assessmentForm.training.c2.q3'
                                          ]" v-on:selected="onSelected('assessmentForm.training.c2', $event)">
                    </checkgroup>
                  </div>
                </div>
                <div class="col-md-3 full-tab-border-right">
                  <h6 class="tab-column-heading">{{ $t('assessmentForm.training.c3.title') }}</h6>
                  <div class="mt-4">
                    <checkgroup storeKey="training.c3" v-bind:values="[
                                          'assessmentForm.training.c3.q1',
                                          'assessmentForm.training.c3.q2',
                                          'assessmentForm.training.c3.q3'
                                          ]" v-on:selected="onSelected('assessmentForm.training.c3', $event)">
                    </checkgroup>
                  </div>
                </div>
                <div class="col-md-3">
                  <h6 class="tab-column-heading">{{ $t('assessmentForm.training.c4.title') }}</h6>
                  <div class="mt-4 last-tab">
                    <checkgroup storeKey="training.c4" v-bind:values="[
                                          'assessmentForm.training.c4.q1',
                                          'assessmentForm.training.c4.q2',
                                          'assessmentForm.training.c4.q3'
                                          ]" v-on:selected="onSelected('assessmentForm.training.c4', $event)">
                    </checkgroup>
                  </div>
                </div>
              </div>
            </b-card-text>
          </b-tab>
          <b-tab title="Management">
            <template v-slot:title>
              <awesome-check :isCompleted="complete.management"></awesome-check>
              Management
            </template>
            <b-card-text class="text-left">
              <div class="row">
                <div class="col-md-4 full-tab-border-right">
                  <h6 class="tab-column-heading">{{ $t('assessmentForm.management.c1.title') }}</h6>

                  <div class="mt-4">
                    <checkgroup storeKey="management.c1" v-bind:values="[
                                          'assessmentForm.management.c1.q1',
                                          'assessmentForm.management.c1.q2',
                                          'assessmentForm.management.c1.q3'
                                          ]" v-on:selected="onSelected('assessmentForm.management.c1', $event)">
                    </checkgroup>
                  </div>
                </div>
                <div class="col-md-4 full-tab-border-right">
                  <h6 class="tab-column-heading">{{ $t('assessmentForm.management.c2.title') }}</h6>
                  <div class="mt-4">
                    <checkgroup storeKey="management.c2" v-bind:values="[
                                          'assessmentForm.management.c2.q1',
                                          'assessmentForm.management.c2.q2',
                                          'assessmentForm.management.c2.q3'
                                          ]" v-on:selected="onSelected('assessmentForm.management.c2', $event)">
                    </checkgroup>
                  </div>
                </div>
                <div class="col-md-4 last-tab">
                  <h6 class="tab-column-heading">{{ $t('assessmentForm.management.c3.title') }}</h6>
                  <div class="mt-4">
                    <checkgroup storeKey="management.c3" v-bind:values="[
                                          'assessmentForm.management.c3.q1',
                                          'assessmentForm.management.c3.q2',
                                          'assessmentForm.management.c3.q3'
                                          ]" v-on:selected="onSelected('assessmentForm.management.c3', $event)">
                    </checkgroup>
                  </div>
                </div>
              </div>
            </b-card-text>
          </b-tab>
          <b-tab title="Dealer Conditions">
            <template v-slot:title>
              <awesome-check :isCompleted="complete.dealerConditions"></awesome-check>
              Dealer Conditions
            </template>
            <b-card-text class="text-left">
              <div class="row">
                <div class="col-md-3 full-tab-border-right">
                  <h6 class="tab-column-heading">{{ $t('assessmentForm.dealerConditions.c1.title') }}</h6>

                  <div class="mt-4">
                    <checkgroup storeKey="dealerConditions.c1" v-bind:values="[
                                          'assessmentForm.dealerConditions.c1.q1',
                                          'assessmentForm.dealerConditions.c1.q2',
                                          'assessmentForm.dealerConditions.c1.q3'
                                          ]" v-on:selected="onSelected('assessmentForm.dealerConditions.c1', $event)">
                    </checkgroup>
                  </div>
                </div>
                <div class="col-md-3 full-tab-border-right">
                  <h6 class="tab-column-heading">{{ $t('assessmentForm.dealerConditions.c2.title') }}</h6>
                  <div class="mt-4">
                    <checkgroup storeKey="dealerConditions.c2" v-bind:values="[
                                          'assessmentForm.dealerConditions.c2.q1',
                                          'assessmentForm.dealerConditions.c2.q2',
                                          'assessmentForm.dealerConditions.c2.q3'
                                          ]" v-on:selected="onSelected('assessmentForm.dealerConditions.c2', $event)">
                    </checkgroup>
                  </div>
                </div>
                <div class="col-md-3 full-tab-border-right">
                  <h6 class="tab-column-heading">{{ $t('assessmentForm.dealerConditions.c3.title') }}</h6>
                  <div class="mt-4">
                    <checkgroup storeKey="dealerConditions.c3" v-bind:values="[
                                          'assessmentForm.dealerConditions.c3.q1',
                                          'assessmentForm.dealerConditions.c3.q2',
                                          'assessmentForm.dealerConditions.c3.q3'
                                          ]" v-on:selected="onSelected('assessmentForm.dealerConditions.c3', $event)">
                    </checkgroup>
                  </div>
                </div>
                <div class="col-md-3">
                  <h6 class="tab-column-heading">{{ $t('assessmentForm.dealerConditions.c4.title') }}</h6>
                  <div class="mt-4 last-tab">
                    <checkgroup storeKey="dealerConditions.c4" v-bind:values="[
                                          'assessmentForm.dealerConditions.c4.q1',
                                          'assessmentForm.dealerConditions.c4.q2',
                                          'assessmentForm.dealerConditions.c4.q3'
                                          ]" v-on:selected="onSelected('assessmentForm.dealerConditions.c4', $event)">
                    </checkgroup>
                  </div>
                </div>
              </div>
            </b-card-text>
          </b-tab>
          <b-tab title="Rewards & Recognition">
            <template v-slot:title>
              <awesome-check :isCompleted="complete.rewards"></awesome-check>
              Rewards & Recognition
            </template>
            <b-card-text class="text-left">
              <div class="row">
                <div class="col-md-4 full-tab-border-right">
                  <h6 class="tab-column-heading">{{ $t('assessmentForm.rewards.c1.title') }}</h6>

                  <div class="mt-4">
                    <checkgroup storeKey="rewards.c1" v-bind:values="[
                                          'assessmentForm.rewards.c1.q1',
                                          'assessmentForm.rewards.c1.q2',
                                          'assessmentForm.rewards.c1.q3'
                                          ]" v-on:selected="onSelected('assessmentForm.rewards.c1', $event)">
                    </checkgroup>
                  </div>
                </div>
                <div class="col-md-4 full-tab-border-right">
                  <h6 class="tab-column-heading">{{ $t('assessmentForm.rewards.c2.title') }}</h6>
                  <div class="mt-4">
                    <checkgroup storeKey="rewards.c2" v-bind:values="[
                                          'assessmentForm.rewards.c2.q1',
                                          'assessmentForm.rewards.c2.q2',
                                          'assessmentForm.rewards.c2.q3'
                                          ]" v-on:selected="onSelected('assessmentForm.rewards.c2', $event)">
                    </checkgroup>
                  </div>
                </div>
                <div class="col-md-4 last-tab">
                  <h6 class="tab-column-heading">{{ $t('assessmentForm.rewards.c3.title') }}</h6>
                  <div class="mt-4">
                    <checkgroup storeKey="rewards.c3" v-bind:values="[
                                          'assessmentForm.rewards.c3.q1',
                                          'assessmentForm.rewards.c3.q2',
                                          'assessmentForm.rewards.c3.q3'
                                          ]" v-on:selected="onSelected('assessmentForm.rewards.c3', $event)">
                    </checkgroup>
                  </div>
                </div>
              </div>
            </b-card-text>
          </b-tab>
        </b-tabs>
      </div>
<!--      </mq-layout>-->
<!--      <mq-layout :mq="['sm', 'md']">-->
<!--        <div class="accordion" role="tablist" ref="test">-->
<!--          <b-card no-body class="mb-2">-->
<!--            <b-card-header v-b-toggle.accordion-1 header-tag="header" class="p-1" role="tab">-->
<!--              <div>-->
<!--                <awesome-check isCompleted></awesome-check>-->
<!--                <span>Compensation</span>-->
<!--              </div>-->
<!--            </b-card-header>-->
<!--            <b-collapse id="accordion-1" visible accordion="my-accordion" role="tabpanel">-->
<!--              <b-card-body>-->
<!--                <div>-->
<!--                  <span class="slide-count">slide 1 of 3</span>-->
<!--                  <div class="slide-info-container">-->
<!--                    <b-button class="slide-button" @click="prev($event)">-->
<!--                      <font-awesome-icon class="fa-fw" :icon="['fal', 'chevron-left']"/>-->
<!--                    </b-button>-->
<!--                    <div class="slide-info">-->
<!--                      <span class="slide-title">ANNUAL INCOME</span>-->
<!--                    </div>-->
<!--                    <b-button class="slide-button" @click="next()">-->
<!--                      <font-awesome-icon class="fa-fw" :icon="['fal', 'chevron-right']"/>-->
<!--                    </b-button>-->
<!--                  </div>-->
<!--                  <b-carousel-->
<!--                    id="carousel-fade"-->
<!--                    :interval="0"-->
<!--                    controls-->
<!--                    data-ref="myCarousel"-->
<!--                    ref="myCarousel"-->
<!--                  >-->
<!--                    <b-carousel-slide>-->
<!--                      <div>-->
<!--                        <b-form-group>-->
<!--                          <b-form-checkbox-group-->
<!--                            id="comp-checkbox-group-1"-->
<!--                            stacked-->
<!--                            size="lg"-->
<!--                            name="comp-check-group-1"-->
<!--                            v-model.lazy="selected"-->
<!--                          >-->
<!--                            <b-form-checkbox name="comp-check-1" value="c1-1" @change="onChange" class="any"><span>We investigate and benchmark pay rates for similar jobs in our area and price technician wages competitively.</span>-->
<!--                            </b-form-checkbox>-->
<!--                            <b-form-checkbox name="comp-check-1" value="c1-2" @change="onChange" class="any"><span>We also survey technicians to assess their satisfaction with compensation.</span>-->
<!--                            </b-form-checkbox>-->
<!--                            <b-form-checkbox name="comp-check-1" value="c1-3" @change="onChange" class="any"><span>We also have a formal process for calculating and assessing the trade-off between raising technician pay or replacing talent.</span>-->
<!--                            </b-form-checkbox>-->
<!--                            <b-form-checkbox name="comp-check-1" value="c1-n" @change="onChange" class="none"><span>None of the above.</span>-->
<!--                            </b-form-checkbox>-->
<!--                          </b-form-checkbox-group>-->
<!--                        </b-form-group>-->
<!--                      </div>-->
<!--                    </b-carousel-slide>-->
<!--                    <b-carousel-slide>-->
<!--                      <div>-->
<!--                        <b-form-group>-->
<!--                          <b-form-checkbox-group-->
<!--                            id="comp-checkbox-group-2"-->
<!--                            stacked-->
<!--                            size="lg"-->
<!--                            name="comp-check-group-2"-->
<!--                            v-model.lazy="selected"-->
<!--                          >-->
<!--                            <b-form-checkbox name="comp-check-2" value="c2-1"><span>We provide guaranteed minimums and production bonuses for new technicians.</span>-->
<!--                            </b-form-checkbox>-->
<!--                            <b-form-checkbox name="comp-check-2" value="c2-2"><span>We also offer 120% hours on Warranty repairs to address pain points new technicians often experience.</span>-->
<!--                            </b-form-checkbox>-->
<!--                            <b-form-checkbox name="comp-check-2" value="c2-3"><span>We also offer an ‘Hourly Bank’ to help supplement new technicians’ production hours.</span>-->
<!--                            </b-form-checkbox>-->
<!--                            <b-form-checkbox name="comp-check-2" value="c2-n"><span>None of the above.</span>-->
<!--                            </b-form-checkbox>-->
<!--                          </b-form-checkbox-group>-->
<!--                        </b-form-group>-->
<!--                      </div>-->
<!--                    </b-carousel-slide>-->
<!--                    <b-carousel-slide>-->
<!--                      <div>-->
<!--                        <b-form-group>-->
<!--                          <b-form-checkbox-group-->
<!--                            id="comp-checkbox-group-3"-->
<!--                            stacked-->
<!--                            size="lg"-->
<!--                            name="comp-check-group-3"-->
<!--                            v-model.lazy="selected"-->
<!--                          >-->
<!--                            <b-form-checkbox name="comp-check-3" value="c3-1"><span>We provide essential benefits (E.g., individual healthcare, 2% 401K match).</span>-->
<!--                            </b-form-checkbox>-->
<!--                            <b-form-checkbox name="comp-check-3" value="c3-2"><span>We offer enhanced benefits (E.g., family healthcare, 3% 401K match, financial education,-->
<!--higher PTO starting rates).</span></b-form-checkbox>-->
<!--                            <b-form-checkbox name="comp-check-3" value="c3-3"><span>We offer premium benefits (E.g., enhanced benefits plus tool incentives, tuition reimbursement).</span>-->
<!--                            </b-form-checkbox>-->
<!--                            <b-form-checkbox name="comp-check-3" value="c3-n"><span>None of the above.</span>-->
<!--                            </b-form-checkbox>-->
<!--                          </b-form-checkbox-group>-->
<!--                        </b-form-group>-->
<!--                      </div>-->
<!--                    </b-carousel-slide>-->
<!--                  </b-carousel>-->
<!--                </div>-->
<!--              </b-card-body>-->
<!--            </b-collapse>-->
<!--          </b-card>-->

<!--          <b-card no-body class="mb-2">-->
<!--            <b-card-header v-b-toggle.accordion-2 header-tag="header" class="p-1" role="tab">-->
<!--              <div>-->
<!--                <awesome-check></awesome-check>-->
<!--                <span>Training</span>-->
<!--              </div>-->
<!--            </b-card-header>-->
<!--            <b-collapse id="accordion-2" accordion="my-accordion" role="tabpanel">-->
<!--              <b-card-body>-->
<!--                <b-card-text>text</b-card-text>-->
<!--              </b-card-body>-->
<!--            </b-collapse>-->
<!--          </b-card>-->

<!--          <b-card no-body class="mb-2">-->
<!--            <b-card-header v-b-toggle.accordion-3 header-tag="header" class="p-1" role="tab">-->
<!--              <div>-->
<!--                <awesome-check></awesome-check>-->
<!--                <span>Management</span>-->
<!--              </div>-->
<!--            </b-card-header>-->
<!--            <b-collapse id="accordion-3" accordion="my-accordion" role="tabpanel">-->
<!--              <b-card-body>-->
<!--                <b-card-text>text</b-card-text>-->
<!--              </b-card-body>-->
<!--            </b-collapse>-->
<!--          </b-card>-->

<!--          <b-card no-body class="mb-2">-->
<!--            <b-card-header v-b-toggle.accordion-4 header-tag="header" class="p-1" role="tab">-->
<!--              <div>-->
<!--                <awesome-check></awesome-check>-->
<!--                <span>Dealer Conditions</span>-->
<!--              </div>-->
<!--            </b-card-header>-->
<!--            <b-collapse id="accordion-4" accordion="my-accordion" role="tabpanel">-->
<!--              <b-card-body>-->
<!--                <b-card-text>text</b-card-text>-->
<!--              </b-card-body>-->
<!--            </b-collapse>-->
<!--          </b-card>-->

<!--          <b-card no-body class="mb-2">-->
<!--            <b-card-header v-b-toggle.accordion-5 header-tag="header" class="p-1" role="tab">-->
<!--              <div>-->
<!--                <awesome-check></awesome-check>-->
<!--                <span>Rewards & Recognition</span>-->
<!--              </div>-->
<!--            </b-card-header>-->
<!--            <b-collapse id="accordion-5" accordion="my-accordion" role="tabpanel">-->
<!--              <b-card-body>-->
<!--                <b-card-text>text</b-card-text>-->
<!--              </b-card-body>-->
<!--            </b-collapse>-->
<!--          </b-card>-->
<!--        </div>-->
<!--      </mq-layout>-->

    </div>
  </div>
</template>

<script>
import { sentenceCase, titleize } from '@/lib/string_helper';
import ApiService from '@/services/api.service';
import AwesomeCheck from "./AwesomeCheck";
import Checkgroup from "@/components/Checkgroup";
import { mapState, mapMutations } from 'vuex';
import _ from "lodash";

export default {
  name: "Form",
  components: {Checkgroup, AwesomeCheck},
  data() {
    return {
      selected: [],
      formSelections: {},
      assessment: null,
      complete: {
        compensation: false,
        training: false,
        management: false,
        dealerConditions: false,
        rewards: false
      },
      ready: false,
    }
  },
  created() {
    this.findOrCreateAssessment();
  },
  methods: {
    findOrCreateAssessment() {
      const params = {
        'query[s]': 'updated_at desc',
        'query[dealership_eq]': this.currentDealership.name.replace('\'', ''),
        'query[completed_false]': 1,
        per_page: 1
      };
      ApiService.query('api/v1/assessments', { params })
      .then((data) => {
        if (data.data.length > 0) {
          this.assessment = data.data[0];
          this.formSelections = data.data[0].form_checkboxes;
          if (this.formSelections !== null) {
            localStorage.setItem('assessmentForm', JSON.stringify(this.formSelections));
            this.loadCurrentBenchmarks();
          } else {
            this.formSelections = {}

            let form = {
              "assessmentForm.compensation.c1": [],
              "assessmentForm.compensation.c2": [],
              "assessmentForm.compensation.c3": [],
              "assessmentForm.training.c1": [],
              "assessmentForm.training.c2": [],
              "assessmentForm.training.c3": [],
              "assessmentForm.training.c4": [],
              "assessmentForm.management.c1": [],
              "assessmentForm.management.c2": [],
              "assessmentForm.management.c3": [],
              "assessmentForm.dealerConditions.c1": [],
              "assessmentForm.dealerConditions.c2": [],
              "assessmentForm.dealerConditions.c3": [],
              "assessmentForm.dealerConditions.c4": [],
              "assessmentForm.rewards.c1": [],
              "assessmentForm.rewards.c2": [],
              "assessmentForm.rewards.c3": [],
            }

            this.formSelections = form;

            var benchmarks = [
              {
                name: "Compensation",
                key: "compensation",
                categories: [
                  {
                    name: "Annual Income",
                    key: "c1",
                    checked: [
                      // "assessmentForm.compensation.c1.q1",
                      // "assessmentForm.compensation.c1.q2",
                      // "assessmentForm.compensation.c1.q3",
                      // "uncheckAll",
                    ]
                  },{
                    name: "Pay Plan Methodology and Bonus Structure",
                    key: "c2",
                    checked: [
                      // "assessmentForm.compensation.c2.q1",
                      // "assessmentForm.compensation.c2.q2",
                      // "assessmentForm.compensation.c2.q3",
                      // "uncheckAll",
                    ]
                  },{
                    name: "Benefits",
                    key: "c3",
                    checked: [
                      // "assessmentForm.compensation.c3.q1",
                      // "assessmentForm.compensation.c3.q2",
                      // "assessmentForm.compensation.c3.q3",
                      // "uncheckAll",
                    ]
                  },
                ]
              },{
                name: "Training",
                key: "training",
                categories: [
                  {
                    name: "Onboarding Process",
                    key: "c1",
                    checked: [
                      // "assessmentForm.training.c1.q1",
                      // "assessmentForm.training.c1.q2",
                      // "assessmentForm.training.c1.q3",
                    ]
                  },{
                    name: "Training Class Policies",
                    key: "c2",
                    checked: [
                      // "assessmentForm.training.c2.q1",
                      // "assessmentForm.training.c2.q2",
                      // "assessmentForm.training.c2.q3",
                    ]
                  },{
                    name: "Career Planning",
                    key: "c3",
                    checked: [
                      // "assessmentForm.training.c3.q1",
                      // "assessmentForm.training.c3.q2",
                      // "assessmentForm.training.c3.q3",
                    ]
                  },{
                    name: "Mentorship Programs",
                    key: "c4",
                    checked: [
                      // "assessmentForm.training.c4.q1",
                      // "assessmentForm.training.c4.q2",
                      // "assessmentForm.training.c4.q3",
                    ]
                  },
                ]
              },{
                name: "Management",
                key: "management",
                categories: [
                  {
                    name: "Meeting Schedule",
                    key: "c1",
                    checked: [
                      // "assessmentForm.management.c1.q1",
                      // "assessmentForm.management.c1.q2",
                      // "assessmentForm.management.c1.q3",
                    ]
                  },{
                    name: "Error Policy",
                    key: "c2",
                    checked: [
                      // "assessmentForm.management.c2.q1",
                      // "assessmentForm.management.c2.q2",
                      // "assessmentForm.management.c2.q3",
                    ]
                  },{
                    name: "Feedback Mechanisms",
                    key: "c3",
                    checked: [
                      // "assessmentForm.management.c3.q1",
                      // "assessmentForm.management.c3.q2",
                      // "assessmentForm.management.c3.q3",
                    ]
                  }
                ]
              },{
                name: "Dealer Conditions",
                key: "dealerConditions",
                categories: [
                  {
                    name: "Dispatch Methods",
                    key: "c1",
                    checked: [
                      // "assessmentForm.dealerConditions.c1.q1",
                      // "assessmentForm.dealerConditions.c1.q2",
                      // "assessmentForm.dealerConditions.c1.q3",
                    ]
                  },{
                    name: "Work Processes",
                    key: "c2",
                    checked: [
                      // "assessmentForm.dealerConditions.c2.q1",
                      // "assessmentForm.dealerConditions.c2.q2",
                      // "assessmentForm.dealerConditions.c2.q3",
                    ]
                  },{
                    name: "Facility Standards",
                    key: "c3",
                    checked: [
                      // "assessmentForm.dealerConditions.c3.q1",
                      // "assessmentForm.dealerConditions.c3.q2",
                      // "assessmentForm.dealerConditions.c3.q3",
                    ]
                  },{
                    name: "Dealership Culture",
                    key: "c4",
                    checked: [
                      // "assessmentForm.dealerConditions.c4.q1",
                      // "assessmentForm.dealerConditions.c4.q2",
                      // "assessmentForm.dealerConditions.c4.q3",
                    ]
                  },
                ]
              },{
                name: "Rewards & Recognition",
                key: "rewards",
                categories: [
                  {
                    name: "Rewards Programs and Special Bonuses",
                    key: "c1",
                    checked: [
                      // "assessmentForm.rewards.c1.q1",
                      // "assessmentForm.rewards.c1.q2",
                      // "assessmentForm.rewards.c1.q3",
                    ]
                  },{
                    name: "Workday Perks",
                    key: "c2",
                    checked: [
                      // "assessmentForm.rewards.c2.q1",
                      // "assessmentForm.rewards.c2.q2",
                      // "assessmentForm.rewards.c2.q3",
                    ]
                  },{
                    name: "Tenure Benefits",
                    key: "c3",
                    checked: [
                      // "assessmentForm.rewards.c3.q1",
                      // "assessmentForm.rewards.c3.q2",
                      // "assessmentForm.rewards.c3.q3",
                    ]
                  },
                ]
              }
            ]
            this.setCurrentBenchmarks(benchmarks);

            this.ready = true;
          }
        } else {
          let form = {
            "assessmentForm.compensation.c1": [],
            "assessmentForm.compensation.c2": [],
            "assessmentForm.compensation.c3": [],
            "assessmentForm.training.c1": [],
            "assessmentForm.training.c2": [],
            "assessmentForm.training.c3": [],
            "assessmentForm.training.c4": [],
            "assessmentForm.management.c1": [],
            "assessmentForm.management.c2": [],
            "assessmentForm.management.c3": [],
            "assessmentForm.dealerConditions.c1": [],
            "assessmentForm.dealerConditions.c2": [],
            "assessmentForm.dealerConditions.c3": [],
            "assessmentForm.dealerConditions.c4": [],
            "assessmentForm.rewards.c1": [],
            "assessmentForm.rewards.c2": [],
            "assessmentForm.rewards.c3": [],
          }

          const oldParams = {
            'query[s]': 'updated_at desc',
            'query[dealership_eq]': this.currentDealership.name.replace('\'', ''),
            'query[completed_false]': 0,
            per_page: 1
          };
          ApiService.query('api/v1/assessments', { params: oldParams })
          .then((data) => {
            let newParams = {}
            if (data.data.length === 0) {
              newParams = {
                assessment: {
                  benchmarks: {},
                  dealership: this.currentDealership.name.replace('\'', ''),
                  form_checkboxes: form,
                }
              }
            } else {
              newParams = {
                assessment: {
                  benchmarks: data.data[0].benchmarks,
                  dealership: this.currentDealership.name.replace('\'', ''),
                  form_checkboxes: data.data[0].form_checkboxes,
                  priority: data.data[0].priority,
                  priority_checkboxes: data.data[0].priority_checkboxes,
                  action_plan: data.data[0].action_plan,
                },
              }
            }

            console.log(newParams)

            ApiService.post('api/v1/assessments', newParams)
              .then((data) => {
                this.assessment = data.data;
                localStorage.setItem('assessmentForm', JSON.stringify(form))
                console.log(data.data);
                this.loadCurrentBenchmarks();
              })
          })



        }
      });
    },
    loadCurrentBenchmarks() {
      var form = JSON.parse(localStorage.getItem('assessmentForm')) || null

      if (form === "null" || form === null) {
        form = null
        console.debug("No previous from data found");
        this.setCurrentBenchmarks(null);
      } else {
        console.debug("Loading previous from data");
        // console.log(form);

        var benchmarks = [
          {
            name: "Compensation",
            key: "compensation",
            categories: [
              {
                name: "Annual Income",
                key: "c1",
                checked: [
                  // "assessmentForm.compensation.c1.q1",
                  // "assessmentForm.compensation.c1.q2",
                  // "assessmentForm.compensation.c1.q3",
                  // "uncheckAll",
                ]
              },{
                name: "Pay Plan Methodology and Bonus Structure",
                key: "c2",
                checked: [
                  // "assessmentForm.compensation.c2.q1",
                  // "assessmentForm.compensation.c2.q2",
                  // "assessmentForm.compensation.c2.q3",
                  // "uncheckAll",
                ]
              },{
                name: "Benefits",
                key: "c3",
                checked: [
                  // "assessmentForm.compensation.c3.q1",
                  // "assessmentForm.compensation.c3.q2",
                  // "assessmentForm.compensation.c3.q3",
                  // "uncheckAll",
                ]
              },
            ]
          },{
            name: "Training",
            key: "training",
            categories: [
              {
                name: "Onboarding Process",
                key: "c1",
                checked: [
                  // "assessmentForm.training.c1.q1",
                  // "assessmentForm.training.c1.q2",
                  // "assessmentForm.training.c1.q3",
                ]
              },{
                name: "Training Class Policies",
                key: "c2",
                checked: [
                  // "assessmentForm.training.c2.q1",
                  // "assessmentForm.training.c2.q2",
                  // "assessmentForm.training.c2.q3",
                ]
              },{
                name: "Career Planning",
                key: "c3",
                checked: [
                  // "assessmentForm.training.c3.q1",
                  // "assessmentForm.training.c3.q2",
                  // "assessmentForm.training.c3.q3",
                ]
              },{
                name: "Mentorship Programs",
                key: "c4",
                checked: [
                  // "assessmentForm.training.c4.q1",
                  // "assessmentForm.training.c4.q2",
                  // "assessmentForm.training.c4.q3",
                ]
              },
            ]
          },{
            name: "Management",
            key: "management",
            categories: [
              {
                name: "Meeting Schedule",
                key: "c1",
                checked: [
                  // "assessmentForm.management.c1.q1",
                  // "assessmentForm.management.c1.q2",
                  // "assessmentForm.management.c1.q3",
                ]
              },{
                name: "Error Policy",
                key: "c2",
                checked: [
                  // "assessmentForm.management.c2.q1",
                  // "assessmentForm.management.c2.q2",
                  // "assessmentForm.management.c2.q3",
                ]
              },{
                name: "Feedback Mechanisms",
                key: "c3",
                checked: [
                  // "assessmentForm.management.c3.q1",
                  // "assessmentForm.management.c3.q2",
                  // "assessmentForm.management.c3.q3",
                ]
              }
            ]
          },{
            name: "Dealer Conditions",
            key: "dealerConditions",
            categories: [
              {
                name: "Dispatch Methods",
                key: "c1",
                checked: [
                  // "assessmentForm.dealerConditions.c1.q1",
                  // "assessmentForm.dealerConditions.c1.q2",
                  // "assessmentForm.dealerConditions.c1.q3",
                ]
              },{
                name: "Work Processes",
                key: "c2",
                checked: [
                  // "assessmentForm.dealerConditions.c2.q1",
                  // "assessmentForm.dealerConditions.c2.q2",
                  // "assessmentForm.dealerConditions.c2.q3",
                ]
              },{
                name: "Facility Standards",
                key: "c3",
                checked: [
                  // "assessmentForm.dealerConditions.c3.q1",
                  // "assessmentForm.dealerConditions.c3.q2",
                  // "assessmentForm.dealerConditions.c3.q3",
                ]
              },{
                name: "Dealership Culture",
                key: "c4",
                checked: [
                  // "assessmentForm.dealerConditions.c4.q1",
                  // "assessmentForm.dealerConditions.c4.q2",
                  // "assessmentForm.dealerConditions.c4.q3",
                ]
              },
            ]
          },{
            name: "Rewards & Recognition",
            key: "rewards",
            categories: [
              {
                name: "Rewards Programs and Special Bonuses",
                key: "c1",
                checked: [
                  // "assessmentForm.rewards.c1.q1",
                  // "assessmentForm.rewards.c1.q2",
                  // "assessmentForm.rewards.c1.q3",
                ]
              },{
                name: "Workday Perks",
                key: "c2",
                checked: [
                  // "assessmentForm.rewards.c2.q1",
                  // "assessmentForm.rewards.c2.q2",
                  // "assessmentForm.rewards.c2.q3",
                ]
              },{
                name: "Tenure Benefits",
                key: "c3",
                checked: [
                  // "assessmentForm.rewards.c3.q1",
                  // "assessmentForm.rewards.c3.q2",
                  // "assessmentForm.rewards.c3.q3",
                ]
              },
            ]
          }
        ]

        if (form["assessmentForm.compensation.c1"].includes("assessmentForm.compensation.c1.q1")) benchmarks[0].categories[0].checked.push("assessmentForm.compensation.c1.q1")
        if (form["assessmentForm.compensation.c1"].includes("assessmentForm.compensation.c1.q2")) benchmarks[0].categories[0].checked.push("assessmentForm.compensation.c1.q2")
        if (form["assessmentForm.compensation.c1"].includes("assessmentForm.compensation.c1.q3")) benchmarks[0].categories[0].checked.push("assessmentForm.compensation.c1.q3")
        if (form["assessmentForm.compensation.c1"].includes("uncheckAll")) benchmarks[0].categories[0].checked.push("uncheckAll")
        if (form["assessmentForm.compensation.c2"].includes("assessmentForm.compensation.c2.q1")) benchmarks[0].categories[1].checked.push("assessmentForm.compensation.c2.q1")
        if (form["assessmentForm.compensation.c2"].includes("assessmentForm.compensation.c2.q2")) benchmarks[0].categories[1].checked.push("assessmentForm.compensation.c2.q2")
        if (form["assessmentForm.compensation.c2"].includes("assessmentForm.compensation.c2.q3")) benchmarks[0].categories[1].checked.push("assessmentForm.compensation.c2.q3")
        if (form["assessmentForm.compensation.c2"].includes("uncheckAll")) benchmarks[0].categories[1].checked.push("uncheckAll")
        if (form["assessmentForm.compensation.c3"].includes("assessmentForm.compensation.c3.q1")) benchmarks[0].categories[2].checked.push("assessmentForm.compensation.c3.q1")
        if (form["assessmentForm.compensation.c3"].includes("assessmentForm.compensation.c3.q2")) benchmarks[0].categories[2].checked.push("assessmentForm.compensation.c3.q2")
        if (form["assessmentForm.compensation.c3"].includes("assessmentForm.compensation.c3.q3")) benchmarks[0].categories[2].checked.push("assessmentForm.compensation.c3.q3")
        if (form["assessmentForm.compensation.c3"].includes("uncheckAll")) benchmarks[0].categories[2].checked.push("uncheckAll")

        if (form["assessmentForm.training.c1"].includes("assessmentForm.training.c1.q1")) benchmarks[1].categories[0].checked.push("assessmentForm.training.c1.q1")
        if (form["assessmentForm.training.c1"].includes("assessmentForm.training.c1.q2")) benchmarks[1].categories[0].checked.push("assessmentForm.training.c1.q2")
        if (form["assessmentForm.training.c1"].includes("assessmentForm.training.c1.q3")) benchmarks[1].categories[0].checked.push("assessmentForm.training.c1.q3")
        if (form["assessmentForm.training.c1"].includes("uncheckAll")) benchmarks[1].categories[0].checked.push("uncheckAll")
        if (form["assessmentForm.training.c2"].includes("assessmentForm.training.c2.q1")) benchmarks[1].categories[1].checked.push("assessmentForm.training.c2.q1")
        if (form["assessmentForm.training.c2"].includes("assessmentForm.training.c2.q2")) benchmarks[1].categories[1].checked.push("assessmentForm.training.c2.q2")
        if (form["assessmentForm.training.c2"].includes("assessmentForm.training.c2.q3")) benchmarks[1].categories[1].checked.push("assessmentForm.training.c2.q3")
        if (form["assessmentForm.training.c2"].includes("uncheckAll")) benchmarks[1].categories[1].checked.push("uncheckAll")
        if (form["assessmentForm.training.c3"].includes("assessmentForm.training.c3.q1")) benchmarks[1].categories[2].checked.push("assessmentForm.training.c3.q1")
        if (form["assessmentForm.training.c3"].includes("assessmentForm.training.c3.q2")) benchmarks[1].categories[2].checked.push("assessmentForm.training.c3.q2")
        if (form["assessmentForm.training.c3"].includes("assessmentForm.training.c3.q3")) benchmarks[1].categories[2].checked.push("assessmentForm.training.c3.q3")
        if (form["assessmentForm.training.c3"].includes("uncheckAll")) benchmarks[1].categories[2].checked.push("uncheckAll")
        if (form["assessmentForm.training.c4"].includes("assessmentForm.training.c4.q1")) benchmarks[1].categories[3].checked.push("assessmentForm.training.c4.q1")
        if (form["assessmentForm.training.c4"].includes("assessmentForm.training.c4.q2")) benchmarks[1].categories[3].checked.push("assessmentForm.training.c4.q2")
        if (form["assessmentForm.training.c4"].includes("assessmentForm.training.c4.q3")) benchmarks[1].categories[3].checked.push("assessmentForm.training.c4.q3")
        if (form["assessmentForm.training.c4"].includes("uncheckAll")) benchmarks[1].categories[3].checked.push("uncheckAll")

        if (form["assessmentForm.management.c1"].includes("assessmentForm.management.c1.q1")) benchmarks[2].categories[0].checked.push("assessmentForm.management.c1.q1")
        if (form["assessmentForm.management.c1"].includes("assessmentForm.management.c1.q2")) benchmarks[2].categories[0].checked.push("assessmentForm.management.c1.q2")
        if (form["assessmentForm.management.c1"].includes("assessmentForm.management.c1.q3")) benchmarks[2].categories[0].checked.push("assessmentForm.management.c1.q3")
        if (form["assessmentForm.management.c1"].includes("uncheckAll")) benchmarks[2].categories[0].checked.push("uncheckAll")
        if (form["assessmentForm.management.c2"].includes("assessmentForm.management.c2.q1")) benchmarks[2].categories[1].checked.push("assessmentForm.management.c2.q1")
        if (form["assessmentForm.management.c2"].includes("assessmentForm.management.c2.q2")) benchmarks[2].categories[1].checked.push("assessmentForm.management.c2.q2")
        if (form["assessmentForm.management.c2"].includes("assessmentForm.management.c2.q3")) benchmarks[2].categories[1].checked.push("assessmentForm.management.c2.q3")
        if (form["assessmentForm.management.c2"].includes("uncheckAll")) benchmarks[2].categories[1].checked.push("uncheckAll")
        if (form["assessmentForm.management.c3"].includes("assessmentForm.management.c3.q1")) benchmarks[2].categories[2].checked.push("assessmentForm.management.c3.q1")
        if (form["assessmentForm.management.c3"].includes("assessmentForm.management.c3.q2")) benchmarks[2].categories[2].checked.push("assessmentForm.management.c3.q2")
        if (form["assessmentForm.management.c3"].includes("assessmentForm.management.c3.q3")) benchmarks[2].categories[2].checked.push("assessmentForm.management.c3.q3")
        if (form["assessmentForm.management.c3"].includes("uncheckAll")) benchmarks[2].categories[2].checked.push("uncheckAll")

        if (form["assessmentForm.dealerConditions.c1"].includes("assessmentForm.dealerConditions.c1.q1")) benchmarks[3].categories[0].checked.push("assessmentForm.dealerConditions.c1.q1")
        if (form["assessmentForm.dealerConditions.c1"].includes("assessmentForm.dealerConditions.c1.q2")) benchmarks[3].categories[0].checked.push("assessmentForm.dealerConditions.c1.q2")
        if (form["assessmentForm.dealerConditions.c1"].includes("assessmentForm.dealerConditions.c1.q3")) benchmarks[3].categories[0].checked.push("assessmentForm.dealerConditions.c1.q3")
        if (form["assessmentForm.dealerConditions.c1"].includes("uncheckAll")) benchmarks[3].categories[0].checked.push("uncheckAll")
        if (form["assessmentForm.dealerConditions.c2"].includes("assessmentForm.dealerConditions.c2.q1")) benchmarks[3].categories[1].checked.push("assessmentForm.dealerConditions.c2.q1")
        if (form["assessmentForm.dealerConditions.c2"].includes("assessmentForm.dealerConditions.c2.q2")) benchmarks[3].categories[1].checked.push("assessmentForm.dealerConditions.c2.q2")
        if (form["assessmentForm.dealerConditions.c2"].includes("assessmentForm.dealerConditions.c2.q3")) benchmarks[3].categories[1].checked.push("assessmentForm.dealerConditions.c2.q3")
        if (form["assessmentForm.dealerConditions.c2"].includes("uncheckAll")) benchmarks[3].categories[1].checked.push("uncheckAll")
        if (form["assessmentForm.dealerConditions.c3"].includes("assessmentForm.dealerConditions.c3.q1")) benchmarks[3].categories[2].checked.push("assessmentForm.dealerConditions.c3.q1")
        if (form["assessmentForm.dealerConditions.c3"].includes("assessmentForm.dealerConditions.c3.q2")) benchmarks[3].categories[2].checked.push("assessmentForm.dealerConditions.c3.q2")
        if (form["assessmentForm.dealerConditions.c3"].includes("assessmentForm.dealerConditions.c3.q3")) benchmarks[3].categories[2].checked.push("assessmentForm.dealerConditions.c3.q3")
        if (form["assessmentForm.dealerConditions.c3"].includes("uncheckAll")) benchmarks[3].categories[2].checked.push("uncheckAll")
        if (form["assessmentForm.dealerConditions.c4"].includes("assessmentForm.dealerConditions.c4.q1")) benchmarks[3].categories[3].checked.push("assessmentForm.dealerConditions.c4.q1")
        if (form["assessmentForm.dealerConditions.c4"].includes("assessmentForm.dealerConditions.c4.q2")) benchmarks[3].categories[3].checked.push("assessmentForm.dealerConditions.c4.q2")
        if (form["assessmentForm.dealerConditions.c4"].includes("assessmentForm.dealerConditions.c4.q3")) benchmarks[3].categories[3].checked.push("assessmentForm.dealerConditions.c4.q3")
        if (form["assessmentForm.dealerConditions.c4"].includes("uncheckAll")) benchmarks[3].categories[3].checked.push("uncheckAll")

        if (form["assessmentForm.rewards.c1"].includes("assessmentForm.rewards.c1.q1")) benchmarks[4].categories[0].checked.push("assessmentForm.rewards.c1.q1")
        if (form["assessmentForm.rewards.c1"].includes("assessmentForm.rewards.c1.q2")) benchmarks[4].categories[0].checked.push("assessmentForm.rewards.c1.q2")
        if (form["assessmentForm.rewards.c1"].includes("assessmentForm.rewards.c1.q3")) benchmarks[4].categories[0].checked.push("assessmentForm.rewards.c1.q3")
        if (form["assessmentForm.rewards.c1"].includes("uncheckAll")) benchmarks[4].categories[0].checked.push("uncheckAll")
        if (form["assessmentForm.rewards.c2"].includes("assessmentForm.rewards.c2.q1")) benchmarks[4].categories[1].checked.push("assessmentForm.rewards.c2.q1")
        if (form["assessmentForm.rewards.c2"].includes("assessmentForm.rewards.c2.q2")) benchmarks[4].categories[1].checked.push("assessmentForm.rewards.c2.q2")
        if (form["assessmentForm.rewards.c2"].includes("assessmentForm.rewards.c2.q3")) benchmarks[4].categories[1].checked.push("assessmentForm.rewards.c2.q3")
        if (form["assessmentForm.rewards.c2"].includes("uncheckAll")) benchmarks[4].categories[1].checked.push("uncheckAll")
        if (form["assessmentForm.rewards.c3"].includes("assessmentForm.rewards.c3.q1")) benchmarks[4].categories[2].checked.push("assessmentForm.rewards.c3.q1")
        if (form["assessmentForm.rewards.c3"].includes("assessmentForm.rewards.c3.q2")) benchmarks[4].categories[2].checked.push("assessmentForm.rewards.c3.q2")
        if (form["assessmentForm.rewards.c3"].includes("assessmentForm.rewards.c3.q3")) benchmarks[4].categories[2].checked.push("assessmentForm.rewards.c3.q3")
        if (form["assessmentForm.rewards.c3"].includes("uncheckAll")) benchmarks[4].categories[2].checked.push("uncheckAll")


        this.setCurrentBenchmarks(benchmarks);

        this.ready = true
      }
    },
    loadPreviousSelections() {
      var form = JSON.parse(localStorage.getItem('assessmentForm'))

      console.log("form", form)

      if (form == null) return

      // console.log((form["assessmentForm.compensation.c1"].includes("assessmentForm.compensation.c1.q1")))
      // console.log(document.querySelectorAll('[value="assessmentForm.compensation.c1.q1"]')[0].click())

      // TODO: Make this not the worst thing ever
      if (form["assessmentForm.compensation.c1"].includes("assessmentForm.compensation.c1.q1")) document.querySelectorAll('[value="assessmentForm.compensation.c1.q1"]')[0].checked = true;
      if (form["assessmentForm.compensation.c1"].includes("assessmentForm.compensation.c1.q2")) document.querySelectorAll('[value="assessmentForm.compensation.c1.q2"]')[0].checked = true;
      if (form["assessmentForm.compensation.c1"].includes("assessmentForm.compensation.c1.q3")) document.querySelectorAll('[value="assessmentForm.compensation.c1.q3"]')[0].checked = true;
      if (form["assessmentForm.compensation.c1"].includes("uncheckAll")) document.querySelectorAll('[value="assessmentForm.compensation.c1.q3"]')[0].parentElement.parentElement.nextSibling.firstChild.checked = true;
      if (form["assessmentForm.compensation.c2"].includes("assessmentForm.compensation.c2.q1")) document.querySelectorAll('[value="assessmentForm.compensation.c2.q1"]')[0].checked = true;
      if (form["assessmentForm.compensation.c2"].includes("assessmentForm.compensation.c2.q2")) document.querySelectorAll('[value="assessmentForm.compensation.c2.q2"]')[0].checked = true;
      if (form["assessmentForm.compensation.c2"].includes("assessmentForm.compensation.c2.q3")) document.querySelectorAll('[value="assessmentForm.compensation.c2.q3"]')[0].checked = true;
      if (form["assessmentForm.compensation.c2"].includes("uncheckAll")) document.querySelectorAll('[value="assessmentForm.compensation.c2.q3"]')[0].parentElement.parentElement.nextSibling.firstChild.checked = true;
      if (form["assessmentForm.compensation.c3"].includes("assessmentForm.compensation.c3.q1")) document.querySelectorAll('[value="assessmentForm.compensation.c3.q1"]')[0].checked = true;
      if (form["assessmentForm.compensation.c3"].includes("assessmentForm.compensation.c3.q2")) document.querySelectorAll('[value="assessmentForm.compensation.c3.q2"]')[0].checked = true;
      if (form["assessmentForm.compensation.c3"].includes("assessmentForm.compensation.c3.q3")) document.querySelectorAll('[value="assessmentForm.compensation.c3.q3"]')[0].checked = true;
      if (form["assessmentForm.compensation.c3"].includes("uncheckAll")) document.querySelectorAll('[value="assessmentForm.compensation.c3.q3"]')[0].parentElement.parentElement.nextSibling.firstChild.checked = true;

      if (form["assessmentForm.training.c1"].includes("assessmentForm.training.c1.q1")) document.querySelectorAll('[value="assessmentForm.training.c1.q1"]')[0].checked = true;
      if (form["assessmentForm.training.c1"].includes("assessmentForm.training.c1.q2")) document.querySelectorAll('[value="assessmentForm.training.c1.q2"]')[0].checked = true;
      if (form["assessmentForm.training.c1"].includes("assessmentForm.training.c1.q3")) document.querySelectorAll('[value="assessmentForm.training.c1.q3"]')[0].checked = true;
      if (form["assessmentForm.training.c1"].includes("uncheckAll")) document.querySelectorAll('[value="assessmentForm.training.c1.q3"]')[0].parentElement.parentElement.nextSibling.firstChild.checked = true;
      if (form["assessmentForm.training.c2"].includes("assessmentForm.training.c2.q1")) document.querySelectorAll('[value="assessmentForm.training.c2.q1"]')[0].checked = true;
      if (form["assessmentForm.training.c2"].includes("assessmentForm.training.c2.q2")) document.querySelectorAll('[value="assessmentForm.training.c2.q2"]')[0].checked = true;
      if (form["assessmentForm.training.c2"].includes("assessmentForm.training.c2.q3")) document.querySelectorAll('[value="assessmentForm.training.c2.q3"]')[0].checked = true;
      if (form["assessmentForm.training.c2"].includes("uncheckAll")) document.querySelectorAll('[value="assessmentForm.training.c2.q3"]')[0].parentElement.parentElement.nextSibling.firstChild.checked = true;
      if (form["assessmentForm.training.c3"].includes("assessmentForm.training.c3.q1")) document.querySelectorAll('[value="assessmentForm.training.c3.q1"]')[0].checked = true;
      if (form["assessmentForm.training.c3"].includes("assessmentForm.training.c3.q2")) document.querySelectorAll('[value="assessmentForm.training.c3.q2"]')[0].checked = true;
      if (form["assessmentForm.training.c3"].includes("assessmentForm.training.c3.q3")) document.querySelectorAll('[value="assessmentForm.training.c3.q3"]')[0].checked = true;
      if (form["assessmentForm.training.c3"].includes("uncheckAll")) document.querySelectorAll('[value="assessmentForm.training.c3.q3"]')[0].parentElement.parentElement.nextSibling.firstChild.checked = true;
      if (form["assessmentForm.training.c4"].includes("assessmentForm.training.c4.q1")) document.querySelectorAll('[value="assessmentForm.training.c4.q1"]')[0].checked = true;
      if (form["assessmentForm.training.c4"].includes("assessmentForm.training.c4.q2")) document.querySelectorAll('[value="assessmentForm.training.c4.q2"]')[0].checked = true;
      if (form["assessmentForm.training.c4"].includes("assessmentForm.training.c4.q3")) document.querySelectorAll('[value="assessmentForm.training.c4.q3"]')[0].checked = true;
      if (form["assessmentForm.training.c4"].includes("uncheckAll")) document.querySelectorAll('[value="assessmentForm.training.c4.q3"]')[0].parentElement.parentElement.nextSibling.firstChild.checked = true;

      if (form["assessmentForm.management.c1"].includes("assessmentForm.management.c1.q1")) document.querySelectorAll('[value="assessmentForm.management.c1.q1"]')[0].checked = true;
      if (form["assessmentForm.management.c1"].includes("assessmentForm.management.c1.q2")) document.querySelectorAll('[value="assessmentForm.management.c1.q2"]')[0].checked = true;
      if (form["assessmentForm.management.c1"].includes("assessmentForm.management.c1.q3")) document.querySelectorAll('[value="assessmentForm.management.c1.q3"]')[0].checked = true;
      if (form["assessmentForm.management.c1"].includes("uncheckAll")) document.querySelectorAll('[value="assessmentForm.management.c1.q3"]')[0].parentElement.parentElement.nextSibling.firstChild.checked = true;
      if (form["assessmentForm.management.c2"].includes("assessmentForm.management.c2.q1")) document.querySelectorAll('[value="assessmentForm.management.c2.q1"]')[0].checked = true;
      if (form["assessmentForm.management.c2"].includes("assessmentForm.management.c2.q2")) document.querySelectorAll('[value="assessmentForm.management.c2.q2"]')[0].checked = true;
      if (form["assessmentForm.management.c2"].includes("assessmentForm.management.c2.q3")) document.querySelectorAll('[value="assessmentForm.management.c2.q3"]')[0].checked = true;
      if (form["assessmentForm.management.c2"].includes("uncheckAll")) document.querySelectorAll('[value="assessmentForm.management.c2.q3"]')[0].parentElement.parentElement.nextSibling.firstChild.checked = true;
      if (form["assessmentForm.management.c3"].includes("assessmentForm.management.c3.q1")) document.querySelectorAll('[value="assessmentForm.management.c3.q1"]')[0].checked = true;
      if (form["assessmentForm.management.c3"].includes("assessmentForm.management.c3.q2")) document.querySelectorAll('[value="assessmentForm.management.c3.q2"]')[0].checked = true;
      if (form["assessmentForm.management.c3"].includes("assessmentForm.management.c3.q3")) document.querySelectorAll('[value="assessmentForm.management.c3.q3"]')[0].checked = true;
      if (form["assessmentForm.management.c3"].includes("uncheckAll")) document.querySelectorAll('[value="assessmentForm.management.c3.q3"]')[0].parentElement.parentElement.nextSibling.firstChild.checked = true;

      if (form["assessmentForm.dealerConditions.c1"].includes("assessmentForm.dealerConditions.c1.q1")) document.querySelectorAll('[value="assessmentForm.dealerConditions.c1.q1"]')[0].checked = true;
      if (form["assessmentForm.dealerConditions.c1"].includes("assessmentForm.dealerConditions.c1.q2")) document.querySelectorAll('[value="assessmentForm.dealerConditions.c1.q2"]')[0].checked = true;
      if (form["assessmentForm.dealerConditions.c1"].includes("assessmentForm.dealerConditions.c1.q3")) document.querySelectorAll('[value="assessmentForm.dealerConditions.c1.q3"]')[0].checked = true;
      if (form["assessmentForm.dealerConditions.c1"].includes("uncheckAll")) document.querySelectorAll('[value="assessmentForm.dealerConditions.c1.q3"]')[0].parentElement.parentElement.nextSibling.firstChild.checked = true;
      if (form["assessmentForm.dealerConditions.c2"].includes("assessmentForm.dealerConditions.c2.q1")) document.querySelectorAll('[value="assessmentForm.dealerConditions.c2.q1"]')[0].checked = true;
      if (form["assessmentForm.dealerConditions.c2"].includes("assessmentForm.dealerConditions.c2.q2")) document.querySelectorAll('[value="assessmentForm.dealerConditions.c2.q2"]')[0].checked = true;
      if (form["assessmentForm.dealerConditions.c2"].includes("assessmentForm.dealerConditions.c2.q3")) document.querySelectorAll('[value="assessmentForm.dealerConditions.c2.q3"]')[0].checked = true;
      if (form["assessmentForm.dealerConditions.c2"].includes("uncheckAll")) document.querySelectorAll('[value="assessmentForm.dealerConditions.c2.q3"]')[0].parentElement.parentElement.nextSibling.firstChild.checked = true;
      if (form["assessmentForm.dealerConditions.c3"].includes("assessmentForm.dealerConditions.c3.q1")) document.querySelectorAll('[value="assessmentForm.dealerConditions.c3.q1"]')[0].checked = true;
      if (form["assessmentForm.dealerConditions.c3"].includes("assessmentForm.dealerConditions.c3.q2")) document.querySelectorAll('[value="assessmentForm.dealerConditions.c3.q2"]')[0].checked = true;
      if (form["assessmentForm.dealerConditions.c3"].includes("assessmentForm.dealerConditions.c3.q3")) document.querySelectorAll('[value="assessmentForm.dealerConditions.c3.q3"]')[0].checked = true;
      if (form["assessmentForm.dealerConditions.c3"].includes("uncheckAll")) document.querySelectorAll('[value="assessmentForm.dealerConditions.c3.q3"]')[0].parentElement.parentElement.nextSibling.firstChild.checked = true;
      if (form["assessmentForm.dealerConditions.c4"].includes("assessmentForm.dealerConditions.c4.q1")) document.querySelectorAll('[value="assessmentForm.dealerConditions.c4.q1"]')[0].checked = true;
      if (form["assessmentForm.dealerConditions.c4"].includes("assessmentForm.dealerConditions.c4.q2")) document.querySelectorAll('[value="assessmentForm.dealerConditions.c4.q2"]')[0].checked = true;
      if (form["assessmentForm.dealerConditions.c4"].includes("assessmentForm.dealerConditions.c4.q3")) document.querySelectorAll('[value="assessmentForm.dealerConditions.c4.q3"]')[0].checked = true;
      if (form["assessmentForm.dealerConditions.c4"].includes("uncheckAll")) document.querySelectorAll('[value="assessmentForm.dealerConditions.c4.q3"]')[0].parentElement.parentElement.nextSibling.firstChild.checked = true;

      if (form["assessmentForm.rewards.c1"].includes("assessmentForm.rewards.c1.q1")) document.querySelectorAll('[value="assessmentForm.rewards.c1.q1"]')[0].checked = true;
      if (form["assessmentForm.rewards.c1"].includes("assessmentForm.rewards.c1.q2")) document.querySelectorAll('[value="assessmentForm.rewards.c1.q2"]')[0].checked = true;
      if (form["assessmentForm.rewards.c1"].includes("assessmentForm.rewards.c1.q3")) document.querySelectorAll('[value="assessmentForm.rewards.c1.q3"]')[0].checked = true;
      if (form["assessmentForm.rewards.c1"].includes("uncheckAll")) document.querySelectorAll('[value="assessmentForm.rewards.c1.q3"]')[0].parentElement.parentElement.nextSibling.firstChild.checked = true;
      if (form["assessmentForm.rewards.c2"].includes("assessmentForm.rewards.c2.q1")) document.querySelectorAll('[value="assessmentForm.rewards.c2.q1"]')[0].checked = true;
      if (form["assessmentForm.rewards.c2"].includes("assessmentForm.rewards.c2.q2")) document.querySelectorAll('[value="assessmentForm.rewards.c2.q2"]')[0].checked = true;
      if (form["assessmentForm.rewards.c2"].includes("assessmentForm.rewards.c2.q3")) document.querySelectorAll('[value="assessmentForm.rewards.c2.q3"]')[0].checked = true;
      if (form["assessmentForm.rewards.c2"].includes("uncheckAll")) document.querySelectorAll('[value="assessmentForm.rewards.c2.q3"]')[0].parentElement.parentElement.nextSibling.firstChild.checked = true;
      if (form["assessmentForm.rewards.c3"].includes("assessmentForm.rewards.c3.q1")) document.querySelectorAll('[value="assessmentForm.rewards.c3.q1"]')[0].checked = true;
      if (form["assessmentForm.rewards.c3"].includes("assessmentForm.rewards.c3.q2")) document.querySelectorAll('[value="assessmentForm.rewards.c3.q2"]')[0].checked = true;
      if (form["assessmentForm.rewards.c3"].includes("assessmentForm.rewards.c3.q3")) document.querySelectorAll('[value="assessmentForm.rewards.c3.q3"]')[0].checked = true;
      if (form["assessmentForm.rewards.c3"].includes("uncheckAll")) document.querySelectorAll('[value="assessmentForm.rewards.c3.q3"]')[0].parentElement.parentElement.nextSibling.firstChild.checked = true;
    },
    onChange() {
      const noneChecked = document.querySelector('.none input[type="checkbox"]');
      const checks = document.querySelectorAll('.any input[type="checkbox"]');
      if (noneChecked.checked) {
        for (let i = 0; i < checks.length; i++) {
          if (checks[i].checked) {
            checks[i].click();
          }
        }
      }
      for (let g = 0; g < checks.length; g++) {
        if (checks[g].checked && noneChecked.checked) {
          noneChecked.click();
        }
      }

    },
    submitForm() {
      // Fetch and transform data
      localStorage.setItem('assessmentForm', JSON.stringify(this.formSelections));

      let benchmarkData = Object.keys(this.$i18n.messages.en.assessmentForm)
        .reduce((acc, current) => {
          const sectionType = titleize(sentenceCase(current));

          // add in the section type root JSON
          if (!acc.some(key => key.section_type === sectionType)) {
            // map the headers into an array of objects
            const assessmentForm = this.$i18n.messages.en.assessmentForm
            const headerKeys = Object.keys(assessmentForm[current]);

            // transform headers so that they can be parsed onto the server
            const headers = headerKeys.map((key) => {
              const data = assessmentForm[current][key];
              // transform checkboxes into questions so they're easier to parse
              const checkboxes = Object.keys(data).filter(key => key !== 'title').map(checkboxKey => {
                const checked = (this.formSelections[`assessmentForm.${current}.${key}`] || []).some(item => item.includes(checkboxKey));
                return {
                  question: assessmentForm[current][key][checkboxKey],
                  checked,
                };
              });
              // return the selected values
              return { title: data.title, checkboxes };
            });

            // setup sections
            const sectionObject = {
              section_type: sectionType,
              headers,
            };
            acc.push(sectionObject);
          }
          return acc;
        }, [])

      const dealership = JSON.parse(localStorage.getItem('selected_dealership'));

      const params = {
        assessment: {
          dealership: dealership.name.replace(/['"]+/g, ''),
          benchmarks: benchmarkData,
          form_checkboxes: this.formSelections,
        },
      };

      ApiService.update('api/v1/assessments', this.assessment.id, params)
        .then((data) => {
          this.setCurrentAssessment(data.data)
          this.$router.push({ name: 'Report' });
          this.$notify({
            title: "Success!",
            text: "Your assessment was successfully submitted.",
            type: "success",
            duration: 10_000,
            width: 500,
          });
        })
    },
    onSelected(column, selections) {
      this.formSelections[column] = selections

      this.complete.compensation = this.isComplete("compensation")
      this.complete.training = this.isComplete("training")
      this.complete.management = this.isComplete("management")
      this.complete.dealerConditions = this.isComplete("dealerConditions")
      this.complete.rewards = this.isComplete("rewards")
    },
    isComplete(section) {

      for (var i = 1; i <= 3; i++) {
        if (this.formSelections['assessmentForm.' + section + '.c' + i] === undefined) return false
        if (this.formSelections['assessmentForm.' + section + '.c' + i].length < 1) return false
      }

      if (["training", "dealerConditions"].includes(section)) {
        if (this.formSelections['assessmentForm.' + section + '.c4'] === undefined) return false
        if (this.formSelections['assessmentForm.' + section + '.c4'].length < 1) return false
      }

      return true
    },
    prev(event) {
      console.log(event.target.parentNode.nextSibling.getAttribute("data-ref"));

      this.$refs.myCarousel.prev()
    },
    next() {
      this.$refs.myCarousel.next()
    },
    ...mapMutations(['setCurrentBenchmarks', 'setCurrentAssessment']),
  },
  computed: {
    ...mapState(['currentBenchmarks', 'currentDealership', 'scs']),
    numComplete() {
      return Object.keys(this.complete).map(key => this.complete[key]).filter((value) => value).length;
    },
    canSubmit() {
      return Object.keys(this.complete).map(key => this.complete[key]).every(v => v === true)
    },
  },
  watch: {
    selected: {
      handler: function (newValue) {
        console.log("Selection", newValue)
      }
    },
    formSelections: {
      handler: _.debounce(function (newValue) {
        console.log("Saving")

        let benchmarkData = Object.keys(this.$i18n.messages.en.assessmentForm)
          .reduce((acc, current) => {
            const sectionType = titleize(sentenceCase(current));

            // add in the section type root JSON
            if (!acc.some(key => key.section_type === sectionType)) {
              // map the headers into an array of objects
              const assessmentForm = this.$i18n.messages.en.assessmentForm
              const headerKeys = Object.keys(assessmentForm[current]);

              // transform headers so that they can be parsed onto the server
              const headers = headerKeys.map((key) => {
                const data = assessmentForm[current][key];
                // transform checkboxes into questions so they're easier to parse
                const checkboxes = Object.keys(data).filter(key => key !== 'title').map(checkboxKey => {
                  const checked = (this.formSelections[`assessmentForm.${current}.${key}`] || []).some(item => item.includes(checkboxKey));
                  return {
                    question: assessmentForm[current][key][checkboxKey],
                    checked,
                  };
                });
                // return the selected values
                return { title: data.title, checkboxes };
              });

              // setup sections
              const sectionObject = {
                section_type: sectionType,
                headers,
              };
              acc.push(sectionObject);
            }
            return acc;
          }, [])

        const params = {
          assessment: {
            benchmarks: benchmarkData,
            form_checkboxes: newValue,
          }
        };
        ApiService.update('api/v1/assessments', this.assessment.id, params)
          .then(({ data }) => {
            this.assessment = data;
          })
      }, 1000),
      deep: true
    }
  },
}
</script>

<style lang="scss" scoped>
#form {
  padding: 25px 30px 40px;
  @media (max-width: 576px) {
    padding: 25px 15px 40px;
  }

  @media (max-width: 1100px) {
    padding-left: 5px;
    padding-right: 5px;
  }

  p {
    letter-spacing: .88px;
    line-height: 26px;
  }

  .assessment-btn {
    font-family: FordAntennaCond-Regular, sans-serif;
    background-color: $fordBlue;
    box-shadow: 0 20px 20px 0 rgba(0, 0, 0, 0.1),
    0 10px 10px 0 rgba(0, 0, 0, 0.1);
    font-size: 18px;
    height: 40px;
    display: flex;
    min-width: 280px;
    align-items: center;
    justify-content: center;
    text-align: center;

    @media (max-width: 576px) {
      min-width: 240px;
    }

    &:hover {
      background-color: #2861a4;
    }

    svg {
      padding-left: 15px;
      font-size: 20px;

      path {
        fill: #fff;
      }
    }
    &.disabled {
      opacity: 1;
      background-color: #6c757d;
      &:hover {
        text-decoration: none !important;
        background-color: #546b7d;
        cursor: not-allowed;
      }
    }
  }

  .tabs {
    .tab-column-heading {
      min-height: 60px;
      @extend .tab-heading;
      font-size: 25px;
      font-family: FordAntennaCond-Light, sans-serif;
      @media (max-width: 576px) {
        min-height: 0;
        margin-top: 15px;
      }
    }
  }
}
</style>
